module.exports = __webpack_public_path__ + "img/score-8.fbf885c2.png";